import utils from '@src/common/utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [{
        label: '任务名称',
        prop: 'taskName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center'
      }, {
        label: '所属中队',
        prop: 'securityWorkGroupNames',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        // searchSlot: true,
        search: true,
        overHidden: true,
        span: 5
      },
      {
        label: '车牌号码',
        prop: 'vehicleCode',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center'
      },
      {
        label: '车主姓名',
        prop: 'vehicleOwnerName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '手机号',
        prop: 'vehicleOwnerPhone',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '速度(km/h)',
        prop: 'speed',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '限速(km/h)',
        prop: 'overSpeed',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '允许上浮速度(km/h)',
        prop: 'floatSpeed',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '处理状态',
        prop: 'overSpeedStatus',
        search: true,
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return '待处理'
          } else if (Number(value) === 2) {
            return '不罚款'
          } else if (Number(value) === 3) {
            return '需要罚款'
          }
          return '';
        },
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '待处理'
          } else if (Number(value) === 2) {
            return '不罚款'
          } else if (Number(value) === 3) {
            return '需要罚款'
          }
          return '';
        },
        dicData: [{
            label: '待处理',
            value: '1'
          },
          {
            label: '不罚款',
            value: '2'
          },
          {
            label: '需要罚款',
            value: '3'
          }
        ],
      },
      {
        label: '测速摄像机',
        prop: 'cameras',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '记录时间',
        prop: 'recordTime',
        type: 'datetimerange',
        search: true,
        searchSlot: true,
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
      },
      // {
      //   label: '处罚状态',
      //   prop: 'isAlarm',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   span: 12,
      //   formatter: (row, value) => {
      //     if (Number(value) === 1) {
      //       return '未开罚单'
      //     } else if (Number(value) === 2) {
      //       return '已开罚单'
      //     }else if(Number(value) === 0) {
      //       return '忽略'
      //     }
      //     return '';
      //   },
      //   align: 'center'
      // },
    ]
  }
}
export default tableOption